import $http from "../axios";

const state = {
  products: []
};

const getters = {
  products: state => {
    return state.products;
  }
};

const actions = {
  getProducts({ commit }, storeId) {
    return new Promise((resolve, reject) => {
      $http
        .get(`products?storeId=${storeId}`)
        .then(res => {
          if (res.data.result === "ok") {
            commit("SET_PRODUCTS", res.data.payload);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  }
};

const mutations = {
  SET_PRODUCTS(state, payload) {
    state.products = payload.products;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
